<template>
    <div class="container-fluid mb-4 bg-secondary mt-2 p-3">
        <div class="row">
            <div class="col-md-12">
                <div v-if="displayLedModule">
                    <p class="text-white p-0 m-0">
                        <strong><span class="lead text-primary">{{ product_configurator_id !== 3 ? $t('Luminaire') : $t('Product') }}: {{ generatedProductName ? generatedProductName : 'tempLED RayLine' }}</span></strong><br>
                        <span v-if="generatedSku && product_configurator_id !== 3" class="text-light"><small>{{ $t('Article no.') }}: {{ generatedSku }}</small><br></span>
                        <span v-if="$can('view_prices') && product_configurator_id !== 3">
                            {{ $t('Unit price') }}: <span v-if="calculatedProductPrice !== $t('Calculating...') && calculatedProductPrice && product_configurator_id !== 3">€ </span>
                            <span>{{ calculatedProductPrice ? calculatedProductPrice : $t('Calculating...') }}</span>
                        </span>
                        <br>
                        <span v-if="$can('view_prices') && user.user_project_discount && user.user_project_discount > 0 && calculatedProductPrice !== $t('Calculating...') && calculatedProductPrice && product_configurator_id !== 3">
                            {{ $t('Reduced unit price') }}: € {{  ( calculatedProductPrice - (calculatedProductPrice * user.user_project_discount / 100) ).toFixed(2) }}
                        </span>
                        <span v-if="!$can('view_prices') && product_configurator_id !== 3">{{ $t('Unit price') }}: {{ $t('Only for authorized customers') }}</span>

                    </p>
                    <hr v-if="finalPlanningPrice > 0 && $can('view_prices') && product_configurator_id !== 3">
                    <p class="text-white p-0 m-0" v-if="finalPlanningPrice > 0 && $can('view_prices')">
                        <span v-if="product_configurator_id === 1"><strong><span class="lead text-primary">{{ $t('Lighting line') }}:</span></strong><br></span>
                        {{ $t('Total price') }}: € {{ finalPlanningPrice.toFixed(2) }} (<a href="#" @click.prevent="toggleLuminationLineDetails(!showLuminationLineDetails )">{{ $t('Display details') }}</a>)<br>
                        <span v-if="$can('view_prices') && user.user_project_discount && user.user_project_discount > 0 && finalPlanningPrice > 0">{{ $t('Reduced total price') }}: € {{ ( finalPlanningPrice - (finalPlanningPrice * user.user_project_discount / 100) ).toFixed(2) }}</span>
                    </p>
                    <p class="text-white p-0 m-0 mt-1" v-if="this.totalLuminationLength && this.totalLuminationLength > 0">
                        {{ $t('Total length') }}: {{ (this.totalLuminationLength / 100).toFixed(2) }} m
                    </p>
                    <p class="text-white p-0 m-0 mt-1" v-if="finalPlanningPrice > 0 && $can('view_prices')">
                        {{ $t('Price varies depending on the module arrangement')}}
                    </p>

                </div>
                <table class="table table-dark text-white" v-if="finalPlanningPrice > 0 && ( showLuminationLineDetails || !displayLedModule )">
                    <thead class="thead-light">
                        <tr>
                            <th class="w-50">{{ $t('Product') }}</th>
                            <th class="w-25">{{ $t('Quantity') }}</th>
                            <th class="w-25" v-if="$can('view_prices')">{{ $t('Price') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="luminaireLinePart in luminaireLinePrices" v-if="luminaireLinePart.title !== ''">
                            <td class="w-50">{{ $t(luminaireLinePart.title) }}</td>
                            <td class="w-25">{{ luminaireLinePart.quantity }} {{ $t('pcs.') }}</td>
                            <td class="w-25" v-if="$can('view_prices') && luminaireLinePart.price > 0">€ {{ luminaireLinePart.price.toFixed(2) }}</td>
                        </tr>

                        <tr v-if="$can('view_prices')">
                            <td colspan="2">{{ $t('Total price of the lighting line') }}:</td>
                            <td><span class="text-primary">€ {{ finalPlanningPrice.toFixed(2) }}</span></td>
                        </tr>
                        <tr v-if="$can('view_prices') && user.user_project_discount && user.user_project_discount > 0 && finalPlanningPrice > 0">
                            <td colspan="2">{{ $t('Reduced total price of the lighting line') }}:</td>
                            <td><span class="text-primary">€ {{ ( finalPlanningPrice - (finalPlanningPrice * user.user_project_discount / 100) ).toFixed(2) }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        props: [
            'product_configurator_id',
            'generatedProductName',
            'generatedSku',
            'calculatedProductPrice',
            'finalPlanningPrice',
            'luminaireLinePrices',
            'displayLedModule',
            'totalLuminationLength',
            'specialProducts'
        ],

        data() {
            return {
                showLuminationLineDetails: false,
            }
        },

        methods: {
            toggleLuminationLineDetails(showDetails) {
                this.showLuminationLineDetails = !!showDetails;
            },

        },

        computed: {

            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                permissions: 'auth/permissions'
            }),

        },
    }
</script>
